interface AppEnv {
  environment: string;
  apiBaseUrl: string;
  auth0Domain: string;
  auth0ClientId: string;
  auth0Audience: string;
  auth0Namespace: string;
  /** Auth0 DB connection name — used for the self-service password reset. */
  auth0DbConnection: string;
  sentryDsn: string;
  /** Mobile app install link (TestFlight in beta, App Store later); optional. */
  mobileInstallUrl: string;
}

function required(name: string, value: string | undefined): string {
  if (!value || value.length === 0) {
    throw new Error(`Missing required env var: ${name}`);
  }
  return value;
}

export const env: AppEnv = {
  environment: import.meta.env.MODE,
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "http://localhost:8000",
  auth0Domain: required("VITE_AUTH0_DOMAIN", import.meta.env.VITE_AUTH0_DOMAIN),
  auth0ClientId: required("VITE_AUTH0_CLIENT_ID", import.meta.env.VITE_AUTH0_CLIENT_ID),
  auth0Audience:
    import.meta.env.VITE_AUTH0_AUDIENCE ?? "https://api.ecs-group-command.co.uk",
  auth0Namespace:
    import.meta.env.VITE_AUTH0_NAMESPACE ?? "https://ecs-group-command.co.uk",
  auth0DbConnection:
    import.meta.env.VITE_AUTH0_DB_CONNECTION ?? "Username-Password-Authentication",
  sentryDsn: import.meta.env.VITE_SENTRY_DSN ?? "",
  mobileInstallUrl: import.meta.env.VITE_MOBILE_INSTALL_URL ?? "",
};
